export default __webpack_public_path__ + "static/media/guess-friends-5.f7728c27.jpg";